import {controllers} from "../Controllers/Controller";

export function connectButton() {
    try {
        controllers().menu.rightToggle()
    }catch (e) {

    }
}
